import { html, nothing } from "lit-html";
import { translate } from "@escapio/shared/l10n/translate";

export const classificationTemplate = (classification, superior = false) =>
	html`<span class="classification classification--${classification}">
		${superior ? html`&nbsp;${translate("basic_superior")}` : nothing}</span
	>`;
